import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
    // font-weight: normal;
  }

  body {
    background: #f7f7f7;
  }
`;

export default GlobalStyle;
